var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"parcel_view",attrs:{"type":"button","variant":"primary","size":"sm"},on:{"click":_vm.viewParcel}},[_c('b-icon-eye')],1)}
var staticRenderFns = []

export { render, staticRenderFns }